function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { formatTimestamp } from 'helpers/datetime';
import PolygonIcon from 'svg/polygon.svg';
import MealIcon from 'svg/meal.svg';
import messages from '../messages';
import * as shapes from '../shapes';
import styles from './MealTooltip.pcss';
var _React_PureComponent;
class MealTooltip extends (_React_PureComponent = React.PureComponent) {
    get nutrientsLabel() {
        return {
            carbs: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.carbs)),
            protein: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.protein)),
            energy: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.energy)),
            fat: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.fat))
        };
    }
    getUnit(type) {
        switch(type){
            case 'energy':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.energyUnit));
            default:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.nutrientUnit));
        }
    }
    renderTitle() {
        const { meal } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.mealTooltip__title,
            children: [
                meal.isSnaqImport ? /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/snaq.svg",
                    alt: "snaq.io",
                    className: styles.mealTooltip__snaqIcon
                }) : /*#__PURE__*/ _jsx(MealIcon, {
                    className: styles.mealTooltip__mealIcon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.mealTooltip__titleText,
                    children: meal.name
                })
            ]
        });
    }
    renderDatetime() {
        const { meal } = this.props;
        const date = formatTimestamp(meal.timestamp, 'DD/MM/YYYY');
        const time = formatTimestamp(meal.timestamp, 'HH:mm');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.mealTooltip__datetime,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: date
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: time
                })
            ]
        });
    }
    renderNutrient(name) {
        const value = this.props.meal[name];
        if (!value) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.mealTooltip__nutrient,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        this.nutrientsLabel[name],
                        " (",
                        this.getUnit(name),
                        ")"
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.mealTooltip__nutrientValue,
                    children: this.props.meal[name]
                })
            ]
        });
    }
    renderNutrients() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.mealTooltip__nutrients,
            children: [
                this.renderNutrient('carbs'),
                this.renderNutrient('protein'),
                this.renderNutrient('energy'),
                this.renderNutrient('fat')
            ]
        });
    }
    renderDetails() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.mealTooltip__details,
            children: [
                this.renderDatetime(),
                this.renderNutrients()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.mealTooltip,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.mealTooltip__content,
                children: [
                    this.renderTitle(),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.mealTooltip__separator
                    }),
                    this.renderDetails(),
                    /*#__PURE__*/ _jsx(PolygonIcon, {
                        width: "17",
                        height: "12",
                        className: styles.mealTooltip__polygon
                    })
                ]
            })
        });
    }
}
_define_property(MealTooltip, "propTypes", {
    // Explicit props
    meal: shapes.meal.isRequired
});
export default withStyles(styles)(MealTooltip);
